import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';
import {ParticleCacheService} from '@core/services/particle-cache.service';
import {
  Dynamic_Grid_Data_Request_Parameters,
  User_Specefic_Grid_Filter
} from '@shared/store/actions/virtual-grid.actions';

@Injectable({
  providedIn: 'root'
})
export class OpenPeopleAndRolesDialogueCommandHandler implements IPlatformCommandHandler {
  constructor(public commandService: CommandService,
              public router: Router,
              private dialogService: DialogService,
              public fuseSplashScreenService: FuseSplashScreenService,
              public snackBarService: SnackBarService,
              private particleCacheService: ParticleCacheService) {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const sourceType = command.fieldValues['SourceType'];
    const  flowExecutionId = command.fieldValues['FlowExecutionId'];
    const flowTemplateId = command.fieldValues['FlowTemplateId'];
    const currentNodeId = command.fieldValues['CurrentNodeId'];
    const input = {
      sourceType: sourceType,
      itemId: flowExecutionId || flowTemplateId,
      fieldDefinition: command.fieldValues['FieldDefinition'],
      currentNodeId: currentNodeId
    };
    const dialogModel: DialogModel = DialogModel.create(
      command.title,
      'PeopleAndRolesDialogueComponent',
      input,
      '800px',
      '800px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(res => {
      if (res.action === 'OK') {
        console.log('OK button clicked!');
      }
    });
    return true;
  }
}
